var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"flat":""}},[_c('canvas',{ref:"pieChart",attrs:{"id":"pie-chart"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }